import * as React from "react";
import { TextField, Button, Grid, Box } from "@mui/material";
import Header from "components/Header";
import { toast } from "react-toastify";
import { changePassword } from "state/apis";

const ChangePassword = () => {
    const [passwords, setPasswords] = React.useState({ currentPassword: "", newPassword: "" });
    const handleChange = (e) => { const { name, value } = e.target; setPasswords((prev) => ({ ...prev, [name]: value })); };

    const handleSubmit = async () => {
        if (!passwords.currentPassword || !passwords.newPassword) { toast.error("Please fill in all fields"); return; }
        try {
            const response = await changePassword(passwords);
            toast.success(response.message);
            setPasswords({ currentPassword: "", newPassword: "" });
        } catch (error) {
            if (error.response) toast.error(error.response.data.message);
            else toast.error("An error occurred. Please try again.");
        }
    };

    return (
        <Box sx={{ p: "24px 28px" }}>
            <Header title="Change Password" />
            <Box display="flex" justifyContent="center" mt={4}>
                <Grid container spacing={2.5} sx={{ maxWidth: 480, backgroundColor: "#fff", borderRadius: "8px", p: 3, border: "1px solid #dde2ea", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                    <Grid item xs={12}>
                        <TextField fullWidth label="Current Password" name="currentPassword" type="text" value={passwords.currentPassword} onChange={handleChange} required />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField fullWidth label="New Password" name="newPassword" type="text" value={passwords.newPassword} onChange={handleChange} required />
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" onClick={handleSubmit} fullWidth sx={{ py: 1 }}>Change Password</Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default ChangePassword;
